import { useState, useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import { useIsAirdropSuccess, useIsAirdropFailed } from 'state/airdrop/hooks'

import { Links, TokenSubLinks, getTokenSubLink } from 'constants/link'

import { Step } from './Step'
import { Wrapper } from './Style'

export enum Steps {
  FIRST,
  SECOND,
  THIRD,
}

const stepsData = [
  { value: Steps.FIRST, label: 'prepare' },
  { value: Steps.SECOND, label: 'approve' },
  { value: Steps.THIRD, label: 'airdrop' },
]

const Stepper = () => {
  const location = useLocation()

  const isAirdropFailed = useIsAirdropFailed()
  const isAirdropSuccess = useIsAirdropSuccess()

  const [activeStep, setActiveStep] = useState(Steps.FIRST)

  useEffect(() => {
    switch (location.pathname) {
      case Links.TOKEN:
        onSetActiveStep(Steps.FIRST)
        break
      case getTokenSubLink(TokenSubLinks.APPROVAL):
        onSetActiveStep(Steps.SECOND)
        break
      case getTokenSubLink(TokenSubLinks.AIRDROP):
        onSetActiveStep(Steps.THIRD)
        break
    }
  }, [location.pathname])

  const onSetActiveStep = (_step: number) => {
    setActiveStep(_step)
  }

  const isAirdropComplete = useMemo(() => {
    if (
      activeStep === Steps.THIRD &&
      location.pathname === getTokenSubLink(TokenSubLinks.AIRDROP) &&
      (isAirdropFailed || isAirdropSuccess)
    ) {
      return true
    }
    return false
  }, [activeStep, isAirdropFailed, isAirdropSuccess, location.pathname])

  return (
    <Wrapper activeStep={activeStep}>
      {stepsData.map((step) => (
        <Step
          key={step.value}
          text={step.label}
          step={step.value}
          activeStep={activeStep}
          isAirdropComplete={isAirdropComplete}
        />
      ))}
    </Wrapper>
  )
}

export { Stepper }
